// extracted by mini-css-extract-plugin
export var marginNegative = "_5x-5 _5x-3 _5x-1";
export var marginPositive = "_5x-4 _5x-3 _5x-1";
export var modalContent = "_5x-6";
export var samplesTable = "_5x-8";
export var samplesTableContainer = "_5x-7";
export var statBox = "_5x-a";
export var tableCell = "_5x-1";
export var tableCellCenter = "_5x-2 _5x-1";
export var tableCellRight = "_5x-3 _5x-1";
export var tableHeader = "_5x-0";
export var trackingNumber = "_5x-9";